export default function Roadmap() {
  const weeks = [
    {
      num: "الأسبوع 1",
      title: "استراتيجية المفهوم",
      desc: "نبدأ من حيث ينتهي الآخرون؛ تحليل البراند، استخراج القيم، وبناء الـ Moodboard لنضمن أن تصميمنا مبني على فهم عميق."
    },
    {
      num: "الأسبوع 2",
      title: "هندسة الشعار",
      desc: "تحويل الفكرة إلى واقع باستخدام الشبكات الرياضية (Grid System) لتصميم شعار يتميز بالبساطة والوضوح."
    },
    {
      num: "الأسبوع 3",
      title: "لغة النظام البصري",
      desc: "بناء الألوان الاستراتيجية، ونظام الخطوط، والعناصر الداعمة لتعيش الهوية وتتنفس بمرونة."
    },
    {
      num: "الأسبوع 4",
      title: "العرض والتمكين",
      desc: "تطبيق الهوية وتغليفها وصياغة دليل الهوية لتقديمه للعميل في عرض تقديمي مبهر."
    }
  ];

  return (
    <section id="roadmap" className="py-32 relative overflow-hidden flex flex-col items-center bg-slate-50 dark:bg-zinc-950 transition-colors duration-500">
      {/* Abstract Background Noise */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-[0.03] dark:opacity-10 mix-blend-screen pointer-events-none transition-opacity duration-500"></div>

      <div className="container mx-auto px-4 relative z-10 w-full mb-20 text-center">
        <h2 className="text-lg font-bold text-primary-600 dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2">
          <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
          خطة الدورة
          <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
        </h2>
        <h3 className="text-4xl md:text-6xl font-extrabold text-slate-900 dark:text-white mb-6 leading-tight drop-shadow-sm dark:drop-shadow-md transition-colors duration-500">
          خارطة الطريق <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 to-primary-700 dark:from-primary-400 dark:to-primary-600">نحو الإبداع</span>
        </h3>
        <p className="text-xl text-slate-600 dark:text-zinc-400 font-light max-w-2xl mx-auto leading-relaxed transition-colors duration-500">
          مسار تفاعلي يأخذك خطوة بخطوة من استلام الطلب وحتى تسليم الهوية بكامل تفاصيلها.
        </p>
      </div>

      <div className="container mx-auto px-4 relative z-10 w-full max-w-5xl">

        <div className="relative w-full">
          {/* Central Vertical Line (Glowing Stepping-Stone Path) */}
          <div className="absolute top-4 bottom-4 right-[28px] md:right-1/2 md:translate-x-1/2 w-1.5 bg-gradient-to-b from-transparent via-primary-500 to-transparent shadow-[0_0_15px_#e00000] dark:shadow-[0_0_25px_#e00000] opacity-50 dark:opacity-70 z-0 rounded-full transition-all duration-500"></div>

          <div className="space-y-16 md:space-y-24">
            {weeks.map((week, idx) => {
              const isRightSide = idx % 2 === 0;

              return (
                <div key={idx} className="relative flex items-center w-full group">

                  {/* Glowing Node */}
                  <div className="absolute right-[28.5px] md:right-1/2 translate-x-1/2 w-5 h-5 rounded-full bg-primary-500 shadow-[0_0_15px_#e00000] dark:shadow-[0_0_20px_#e00000] border-4 border-slate-50 dark:border-zinc-950 z-10 group-hover:scale-150 group-hover:shadow-[0_0_25px_#e00000] dark:group-hover:shadow-[0_0_35px_#e00000] transition-all duration-500 animate-[pulse_3s_ease-in-out_infinite]"></div>

                  {/* Horizontal Connection Line (Optional nuance) */}
                  <div className={`hidden md:block absolute top-1/2 right-1/2 translate-y-[-50%] h-px bg-gradient-to-r from-primary-500/0 via-primary-500/30 dark:via-primary-500/50 to-primary-500/0 z-0 transition-all duration-500 opacity-0 group-hover:opacity-100 ${isRightSide ? 'w-[10%] translate-x-full' : 'w-[10%] -translate-x-0'}`}></div>

                  {/* Content Wrappe r*/}
                  <div className={`w-full md:w-1/2 pr-14 md:pr-0 ${isRightSide ? 'md:pl-16' : 'md:pr-16 md:mr-auto'}`}>

                    <div className="bg-white/70 dark:bg-zinc-900/40 backdrop-blur-md border border-slate-200 dark:border-white/10 rounded-lg p-8 hover:border-primary-500/50 dark:hover:border-primary-500/80 hover:bg-slate-50/80 dark:hover:bg-zinc-800/80 transition-all duration-500 group-hover:-translate-y-2 shadow-sm dark:shadow-[0_10px_30px_rgba(0,0,0,0.5)] group-hover:shadow-[0_15px_30px_rgba(224,0,0,0.05)] dark:group-hover:shadow-[0_15px_40px_rgba(224,0,0,0.15)] relative overflow-hidden">

                      {/* Inner Hover Glow */}
                      <div className={`absolute top-0 w-32 h-32 bg-primary-500/10 dark:bg-primary-500/20 rounded-full blur-[30px] dark:blur-[40px] opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none ${isRightSide ? 'right-0 -mt-16 -mr-16' : 'left-0 -mt-16 -ml-16'}`}></div>

                      <div className="relative z-10">
                        <span className="text-primary-600 dark:text-primary-400 font-bold text-lg tracking-wider mb-2 block transition-colors duration-500">{week.num}</span>
                        <h4 className="text-2xl font-extrabold text-slate-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors mb-4 duration-500">{week.title}</h4>
                        <p className="text-slate-600 dark:text-zinc-400 text-lg leading-relaxed font-light transition-colors duration-500">{week.desc}</p>
                      </div>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
